import { useCallback, useContext } from 'react'

import i18n from 'Pods/Shared/I18nThreeDStudio'
import ThreeDStudioPageContext from 'Pods/ThreeDStudio/ThreeDStudioPageContext'

const NAMESPACE = 'three-d-studio'

// Binds i18n to the three-d-studio namespace and the page locale so call sites
// only pass a key. Locale rides on ThreeDStudioPageContext (seeded from the SSR
// `locale` prop) so server and client resolve the same string on this fast page.
export default function useTranslation() {
  const { locale } = useContext(ThreeDStudioPageContext)

  return useCallback(
    (key, options) => i18n.t(key, { ns: NAMESPACE, lng: locale, ...options }),
    [locale]
  )
}
